module.exports = __webpack_public_path__ + "img/13-5.34eb8d0f.svg";